import { initModal, toggleModal } from '../snippets/modal';
import RegionIPDetection from '../helpers/regionDetection';
let modal;
let redirectModal;
let redirectMessageWrapper;
let detectedRegionDomain;
let detectedRegionMessage;
let detectedRegionButton;
let isManualValue = false;
let regions;
const selectors = {
    modal: '#region-selector',
    currentText: '[data-region-selector-current-text]',
    changeRegionButton: '[data-modal-action]',
    changeStayButton: '.modal__button-wrapper [data-modal-close]',
    selectedRegionField: '[data-region-selector-dropdown]',
    openModal: '[data-region-selector-open]',
    redirectModal: '#region-redirector',
    redirectMessage: '.modal__title',
    dataRegions: '[data-other-regions]',
};
const queryParams = () => {
    return new URLSearchParams(window.location.search);
};
const init = () => {
    var _a;
    modal = document.querySelector(selectors.modal);
    redirectModal = document.querySelector(selectors.redirectModal);
    if (redirectModal) {
        redirectMessageWrapper = redirectModal.querySelector(selectors.redirectMessage);
    }
    if (window.regionSelector) {
        regions = (_a = window.regionSelector) === null || _a === void 0 ? void 0 : _a.regions;
        const urlParams = queryParams();
        const manualValue = urlParams.get('m');
        if (manualValue) {
            isManualValue = true;
            localStorage.setItem('ipRegionSwitchedManually', 'true');
        }
        else {
            const ipRegionSwitchedManually = localStorage.getItem('ipRegionSwitchedManually');
            if (ipRegionSwitchedManually === 'true') {
                isManualValue = true;
            }
        }
        // If it was manually redirected, prevent checking region
        initModal();
        renderCurrentRegionText();
        initializeRegionModalTriggers();
        initializeRegionSwitcher();
        // Do ip redirection only if the customer hasn't manually selected a region before
        if (!isManualValue) {
            addEventListeners();
            RegionIPDetection();
        }
    }
};
const addEventListeners = () => {
    // Event triggered once a region is detected from the customers ip
    window.addEventListener('region-country-code-detected', (event) => {
        if (window.regionSelector.regionAutoredirect === true) {
            const detectedCountryCode = event.detail.ipDetectedRegionCode;
            let regionFound = false;
            const currentRegion = regions.find((region) => {
                return region.is_current_store;
            });
            // Loop trough the regions setup in the theme settings
            if (regions) {
                regions.forEach((region) => {
                    if (region.country_codes.includes(detectedCountryCode) && !region.is_current_store) {
                        regionFound = true;
                        detectedRegionDomain = region.domain;
                        detectedRegionMessage = region.region_redirect_message;
                        detectedRegionButton = region.region_redirect_button;
                        initializeRegionRedirect();
                        toggleModal('region-redirector');
                        return;
                    }
                });
            }
            // If a region was not found, verify if the store is the default store, otherwise show the customer the option to redirect to the default region
            if (!regionFound) {
                const default_region = regions.find((region) => {
                    return region.is_default === true;
                });
                if (default_region && !default_region.is_current_store && !currentRegion.country_codes.includes(detectedCountryCode)) {
                    detectedRegionDomain = default_region.domain;
                    detectedRegionMessage = default_region.region_redirect_message;
                    detectedRegionButton = default_region.region_redirect_button;
                    initializeRegionRedirect();
                    toggleModal('region-redirector');
                }
            }
        }
    });
};
// Add text 'Country Name - Currency' to matching elements
const renderCurrentRegionText = () => {
    const currentTexts = document.querySelectorAll(selectors.currentText);
    const otherRegions = document.querySelectorAll(selectors.currentText);
    if (currentTexts.length > 0) {
        Array.from(currentTexts).forEach((currentText) => {
            currentText.innerText = `${window.regionSelector.regions[0].name} - ${window.regionSelector.regions[0].currency}`;
        });
    }
};
// Elements with the data attirbute set in selectors.openModal will open the Region Selector modal
const initializeRegionModalTriggers = () => {
    const regionSelectors = document.querySelectorAll(selectors.openModal);
    if (regionSelectors) {
        for (const regionSelector of regionSelectors) {
            regionSelector.addEventListener('click', (event) => {
                event.preventDefault();
                // This is required when the region selector is opened from the burger menu button to prevent the event propagating to the background
                event.stopPropagation();
                // BurgerMenu.close();
                toggleModal('region-selector');
            });
        }
    }
};
const initializeRegionSwitcher = () => {
    const regionSelectorButton = modal.querySelector(selectors.changeRegionButton);
    if (regionSelectorButton) {
        regionSelectorButton.addEventListener('click', (event) => {
            event.preventDefault();
            const countryNameSelect = document.querySelector(selectors.selectedRegionField);
            if (countryNameSelect) {
                const url = countryNameSelect.value;
                redirectToRegion(url);
            }
        });
    }
};
const initializeRegionRedirect = () => {
    const otherRegionsWrapper = redirectModal.querySelector(selectors.dataRegions);
    const regionChangeButton = redirectModal.querySelector(selectors.changeRegionButton);
    const regionStayButton = redirectModal.querySelector(selectors.changeStayButton);
    if (redirectMessageWrapper) {
        redirectMessageWrapper.innerHTML = detectedRegionMessage;
    }
    if (otherRegionsWrapper) {
        window.regionSelector.regions.forEach((region) => {
            if (!region.is_current_store) {
                otherRegionsWrapper.innerHTML = `${otherRegionsWrapper.innerHTML} <a class="region" href="${region.domain}" aria-label="${region.name}"><img src="${region.flag}"></a>`;
            }
        });
    }
    if (regionStayButton) {
        regionStayButton.addEventListener('click', (event) => {
            event.preventDefault();
            localStorage.setItem('ipRegionSwitchedManually', 'true');
        });
    }
    if (regionChangeButton) {
        const spans = regionChangeButton.querySelectorAll('span');
        spans.forEach((span) => {
            if (detectedRegionButton) {
                span.innerHTML = detectedRegionButton;
            }
        });
        regionChangeButton.addEventListener('click', (event) => {
            event.preventDefault();
            redirectToRegion(detectedRegionDomain);
        });
    }
};
const redirectToRegion = (regionURL) => {
    const pathname = window.location.pathname;
    let manualParam;
    // Set a manual param to prevent readirecting from the selected site
    if (pathname.includes('?')) {
        manualParam = '&m=1';
    }
    else {
        manualParam = '?m=1';
    }
    window.location.href = `${regionURL}${pathname}${manualParam}`;
};
init();
